import { render } from "./ReadTab.vue?vue&type=template&id=e404b4dc&ts=true"
import script from "./ReadTab.vue?vue&type=script&lang=ts"
export * from "./ReadTab.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__